<template>
    <agile id="image-slider" :pauseOnHover="true" :autoplay="true" :autoplaySpeed="autoplaySpeed" :dots="dots" :fade="fade" :speed="speed">
        <div v-for="item in this.slides">
            <img :src="item.image" class="slide" alt="">

            <div v-if="item.slider_header || item.slider_paragraph || (item.button_url && item.button_text)" class="carousel-caption">
                <span v-if="item.slider_header" class="slider-header">{{ item.slider_header }}</span>

                <p v-if="item.slider_paragraph" class="slider-paragraph">{{ item.slider_paragraph }}</p>

                <a v-if="item.button_url && item.button_text" :href="item.button_url" :target="item.button_target" class="button">
                    {{ item.button_text }}
                </a>
            </div>
        </div>

        <template v-slot:prevButton>
            <i v-show="showArrows" class="fa-light fa-chevron-left"></i>
        </template>

        <template v-slot:nextButton>
            <i v-show="showArrows" class="fa-light fa-chevron-right"></i>
        </template>
    </agile>
</template>

<script>
    import {VueAgile} from 'vue-agile'

    export default {
        props: {
            fade: Boolean,
            slides: Array
        },
        components: {
            agile: VueAgile
        },
        data() {
            return {
                autoplaySpeed: 10000,
                dots: this.hasMultipleSlides(this.slides),
                showArrows: this.hasMultipleSlides(this.slides),
                speed: 1000
            }
        },
        methods: {
            hasMultipleSlides: slides => {
                return slides.length > 1;
            }
        }
    }
</script>
